module.exports = __webpack_public_path__ + "img/Septem.3fbc0634.svg";